<script setup lang="ts">
import { RouterView } from 'vue-router';
import { onMounted } from 'vue';
import { useSecurityStore } from '@/stores/security.store.ts';

const securityStore = useSecurityStore();

onMounted(() => {
    securityStore.setupReferrer();
});
</script>

<template>
    <q-layout
        v-if="!$route.meta.disableLayout"
        view="hHh lpR fFf"
        container
        class="column bg-grey-2"
        :class="$route.name"
    >
        <q-page-container>
            <q-page class="column">
                <router-view />
            </q-page>
        </q-page-container>
    </q-layout>
</template>
